var map = {
	"./brand/logo-dark.png": "5551",
	"./gen/agri-app.jpg": "45da",
	"./gen/agri-sensor.jpg": "4d44",
	"./gen/agri-waterfert.jpg": "a219",
	"./gen/cover-agriculture.jpg": "fe09",
	"./gen/cover-enterprise.jpg": "6404",
	"./gen/cover-iot.jpg": "67b0",
	"./gen/cta-bg.jpg": "18fb",
	"./gen/demo-preview.jpg": "40a3",
	"./gen/ent-onsite.jpg": "cf5f",
	"./gen/ent-server.jpg": "b1db",
	"./gen/ent-workshop.jpg": "e171",
	"./gen/hero-about.jpg": "317d",
	"./gen/hero-agriculture.jpg": "7c49",
	"./gen/hero-contact.jpg": "3d2c",
	"./gen/hero-enterprise.jpg": "7876",
	"./gen/hero-home.jpg": "5ef8",
	"./gen/hero-iot.jpg": "2d8b",
	"./gen/iot-cnc.jpg": "35a0",
	"./gen/iot-gateway.jpg": "10b9",
	"./gen/iot-inspect.jpg": "ce2e",
	"./gen/mes-cover.jpg": "aede",
	"./gen/mes-hero.jpg": "2b84",
	"./gen/mes-outcome.jpg": "8da7",
	"./gen/mes-scene-assembly.jpg": "7cbe",
	"./gen/mes-scene-auto.jpg": "5212",
	"./gen/mes-scene-electronics.jpg": "6aef",
	"./gen/mes-scene-food.jpg": "fa9e",
	"./gen/mes-scene-injection.jpg": "f454",
	"./gen/mes-scene-trace.jpg": "727e",
	"./gen/scene-aquaculture.jpg": "41c4",
	"./gen/scene-data.jpg": "e314",
	"./gen/scene-energy.jpg": "d3b5",
	"./gen/scene-factory.jpg": "1027",
	"./gen/scene-field.jpg": "f9e8",
	"./gen/scene-gov.jpg": "28d6",
	"./gen/scene-greenhouse.jpg": "ec59",
	"./gen/scene-remoteops.jpg": "3c42",
	"./gen/scene-smb.jpg": "c970",
	"./gen/wx-qr.png": "480f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0d7a";